import React from "react"
import { Box } from "@mui/material"

const CategoryInformation = ({ shortDescription }: Props) => {
	return (
		<Box>
			{shortDescription && <div dangerouslySetInnerHTML={{ __html: shortDescription }} />}
		</Box>
	)
}

interface Props {
	shortDescription: string
}

export default CategoryInformation
